import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class VendorGridService {
 private readonly vendorUrl = environment.main_url + '/agilelegal/vendors';

  constructor(private readonly http: HttpClient) {}

  getVendorList(pageNumber?: number, pageSize?: number, payload?: any) {
    if (pageNumber && pageSize && payload) {
      return this.http.post<any>(
        `${this.vendorUrl}/filter?pageNumber=${pageNumber}&pageSize=${pageSize}`,
        payload
      );
    }
    // Default case if no pagination or payload is provided
    return this.http.get<any>(`${this.vendorUrl}`);
  }

  saveVendor(payload: any, id?: number) {
    if (id) {
      return this.http.put<any>(`${this.vendorUrl}/${id}`, payload);
    }
    return this.http.post<any>(this.vendorUrl, payload);
  }

}
